import { Stack, Box } from '@mui/material';

interface Props {
  step: number;
}

const styles = {
  stepBox: (active: boolean) => ({
    width: 40,
    height: 6,
    borderRadius: 3,
    backgroundColor: active ? 'primary.main' : 'grey.300',
    transition: 'background 0.2s',
  }),
};

export function StepIndicator({ step }: Props) {
  return (
    <Stack direction="row" justifyContent="center" gap={2} my={3}>
      {[1, 2, 3].map(s => (
        <Box key={s} sx={styles.stepBox(step >= s)} />
      ))}
    </Stack>
  );
}
